import React from 'react';
import './Footer.css';

const Footer = ({ year, creator, iconCreator, bgCreator }) => {
  return (
    <div className="footer-content">
      <div>&copy; {year} Created by: {creator}</div>
      <div>Icon created by: {iconCreator}</div>
      <div>Background photo by: {bgCreator}</div>
    </div>
  );
}

export default Footer;